import React from 'react'
import intl from 'react-intl-universal'

import useLineForm, { FieldNames } from './use-line-form'

// eslint-disable-next-line @typescript-eslint/no-var-requires
const styles = require('./LineForm.styles.scss')

type Props = Pick<
  ReturnType<typeof useLineForm>,
  'fields' | 'fieldErrors' | 'handleFieldChange'
> & {
  // use onBlur to update angular settings object because re-renders caused by onChange janky
  onBlur?: () => void
}

export default function LineForm(props: Props) {
  return (
    <form className={styles.form}>
      <div className="radios">
        <label>
          <input
            type="radio"
            name={'unit' as FieldNames}
            value="words"
            checked={props.fields.unit === 'words'}
            onChange={props.handleFieldChange}
          />
          {intl.get('LineConfiguration.tabs.default.labels.words')}
        </label>
        <label>
          <input
            type="radio"
            name={'unit' as FieldNames}
            value="chars"
            checked={props.fields.unit === 'chars'}
            onChange={props.handleFieldChange}
          />
          {intl.get('LineConfiguration.tabs.default.labels.chars')}
        </label>
      </div>
      <div className="text-field">
        <label>
          {props.fields.unit === 'words'
            ? intl.get('LineConfiguration.tabs.default.labels.words')
            : intl.get('LineConfiguration.tabs.default.labels.chars')}
          <input
            type="text"
            name={'value' as FieldNames}
            className={`form-control${
              props.fieldErrors.value ? ' has-error' : ''
            } input-primary`}
            value={(props.fields.value || '').toString()}
            onChange={props.handleFieldChange}
            disabled={!props.fields.unit}
            onBlur={props.onBlur}
          />
        </label>
        <p className="error-message">{props.fieldErrors.value}</p>
      </div>
      <div className="text-field">
        <label>
          {intl.get('LineConfiguration.tabs.default.labels.lines')}
          <input
            type="text"
            name={'linesPerInch' as FieldNames}
            className={`form-control${
              props.fieldErrors.linesPerInch ? ' has-error' : ''
            } input-primary`}
            value={(props.fields.linesPerInch || '').toString()}
            onChange={props.handleFieldChange}
            onBlur={props.onBlur}
          />
        </label>
        <p className="error-message">{props.fieldErrors.linesPerInch}</p>
      </div>
    </form>
  )
}
